//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'RDR',
  data() {
    return {
      form: {
        fiveHConcentration: '',
        foundationConcentration:'',
      },
      hasScore: false,
      disabled: false,
      num: '',
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        self.hasScore = true;
        self.num = (((form.fiveHConcentration-form.foundationConcentration)/form.fiveHConcentration )* 100).toFixed(0)
        return String(self.num)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/RDR.vue